import _ from "underscore";

import classNames from "classnames";

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from "prop-types";

import React from "react";
import CheckboxClass from "./checkbox";
import HighlighTextClass from "../elements/highlight-text";
import AdvancedComboboxItemClass from "./advanced-combobox-item";
import IconClass from "../elements/icon";
import ArrowSelectInputClass from "../elements/arrow-select-input";
import BasicUtils from "../../utils/basic-utils";
import numeral from "numeral";

const { array, object, string, any, func, bool, oneOfType } = PropTypes;
const Checkbox = React.createFactory(CheckboxClass);
const HighlightText = React.createFactory(HighlighTextClass);
const AdvancedComboboxItem = React.createFactory(AdvancedComboboxItemClass);
const Icon = React.createFactory(IconClass);
const ArrowSelectInput = React.createFactory(ArrowSelectInputClass);

// Expects the follow formats:
// For Groups: {label: "Group Label", items: [...]}
// For Items: {label: "Option Label", value: "Option value", icon: "icon-class", disabled: true}

const SEARCH_HEIGHT = 71;
const SELECT_ALL_HEIGHT = 42;
const DEFAULT_MAX_HEIGHT = 720;

const formatterFactory = function(multiple) {
  if (multiple == null) {
    multiple = false;
  }
  const formatter = (item, isSelected, isHovered, search_query) => (
    <span>
      {(() => {
        if (multiple) {
          return Checkbox({ className: "et--checkbox-small", checked: isSelected });
        } else {
          if (isSelected) {
            return Icon({
              className: "et--advanced-combobox-item--selected",
              icon: "check",
            });
          }
        }
      })()}
      {HighlightText({
        className: "et--advanced-combobox-item--label",
        string: item != null ? item.label : undefined,
        query: BasicUtils.regexEscape(search_query),
      })}
      {item.count || item.icon ? (
        <span className="et--advanced-combobox-item--right-area">
          {item.count ? (
            <span className="et--advanced-combobox-item--count">{numeral(item.count).format("0,0")}</span>
          ) : (
            undefined
          )}
          {item.icon ? <i className={classNames("et--advanced-combobox-item--icon", item.icon)} /> : undefined}
        </span>
      ) : (
        undefined
      )}
    </span>
  );

  return formatter;
};

export default class extends React.Component {
  static displayName = "AdvancedComboboxContent";

  static propTypes = {
    options: oneOfType([array, object]),

    name: string,
    value: any,
    onChange: func, //

    position: string,
    multiple: bool,
    grouped: bool,
    allowChangeAll: bool,
    allowUnselectAll: bool,

    searchable: bool,
    search_placeholder: string,
    initial_search: string,
    onSearch: func, // args: [trimed_query], called on query change

    createFromSearch: func, //

    formatItem: func, //
    formatSelection: func, //
    placeholder: string,
    empty_placeholder: any,
    loading: bool,
    disabled: bool,
    focusOnMount: bool,

    // new stuff...
    isOpenedUp: bool,
    height: any,
    onComplete: func,
  }; // called for multiple=false case where selecting means you're done

  static defaultProps = {
    options: [],
    multiple: false,
    grouped: false,
    searchable: false,
    search_placeholder: "Search...",
    allowChangeAll: false,
    placeholder: "Select Option...",
    empty_placeholder: "No results",
    formatLabel(label) {
      return label;
    },

    formatSelection(selectionText, selection, placeholder, open) {
      return (
        <span>
          <span className="et--advanced-combobox-content--selected-text">{selectionText}</span>
          {open ? Icon({ icon: "chevron-up" }) : Icon({ icon: "chevron-down" })}
        </span>
      );
    },
  };

  state = {
    search: this.props.initial_search || "",
    listScroll: undefined,
    listHeight: undefined,
    selectedIndex: -1,
  };

  componentDidMount() {
    // todo: figure out where focus should actually be called
    if (this.props.searchable) {
      return this.refs.search_box != null ? this.refs.search_box.focus() : undefined;
    }
  }

  componentDidUpdate(prevProps) {
    // If adding/removing data from the list make sure scroll stays put
    if (!_.isUndefined(this.state.listScroll) && this.state.listHeight && this.props.multiple) {
      const new_height = this.refs.list_inner.offsetHeight;
      const new_scroll = this.state.listScroll + (new_height - this.state.listHeight);
      this.refs.list_outer.scrollTop = new_scroll;

      return this.setState({
        listScroll: undefined,
        listHeight: undefined,
        selectedIndex: -1,
      });
    }
  } // reset hover

  getSelectable = () => {
    const list = this.getFilteredList();
    if (this.props.grouped) {
      return _.flatten(_.pluck(list, "items"));
    } else {
      return list;
    }
  };

  getFilteredList = () => {
    if (this.props.searchable && this.state.search && !this.props.onSearch) {
      const query = this.state.search;
      if (this.props.grouped) {
        return _.compact(
          _.map(this.props.options, function(group) {
            if (BasicUtils.matchesSearchQuery(group.label, query)) {
              return group;
            } else {
              const items = _.filter(group.items, item => BasicUtils.matchesSearchQuery(item.label, query));
              if (!_.isEmpty(items)) {
                return _.extend({}, group, { items });
              }
            }
          })
        );
      } else {
        return _.filter(this.props.options, item => BasicUtils.matchesSearchQuery(item.label, query));
      }
    } else {
      return this.props.options;
    }
  };

  getSelectedItem = (item, list) => {
    if (list == null) {
      list = this.props.value;
    }
    return _.clone(_.findWhere(list, { value: item.value }));
  };

  isSelected = item => {
    if (_.isUndefined(this.props.value)) {
      return false;
    }
    if (this.props.multiple) {
      return !!this.getSelectedItem(item);
    } else {
      return item.value === (this.props.value != null ? this.props.value.value : undefined);
    }
  };

  handleSelect = value => {
    if (this.props.multiple) {
      let values = _.map(this.props.value, _.clone);
      const found = this.getSelectedItem(value);

      if (found) {
        values = _.reject(values, val => val.value === found.value);
      } else {
        values.push(value);
      }

      this.setState({
        listScroll: this.refs.list_outer.scrollTop,
        listHeight: this.refs.list_inner.offsetHeight,
      });
      if (typeof this.props.onChange === "function") {
        this.props.onChange(values);
      }
    } else {
      if (typeof this.props.onChange === "function") {
        this.props.onChange(value);
      }
    }

    if (!this.props.multiple) {
      this.setState({ search: "" });
      return typeof this.props.onComplete === "function" ? this.props.onComplete() : undefined;
    }
  };

  handleHover = (item, index, evt) => {
    return this.setState({ selectedIndex: index });
  };

  handleKeyEnter = () => {
    const { selectedIndex } = this.state;
    const selectable_options = this.getSelectable();
    let selected = selectable_options[selectedIndex];
    if (_.isEmpty(selectable_options) && _.isFunction(this.props.createFromSearch)) {
      selected = this.props.createFromSearch(this.state.search);
    }

    if (selected && !(selected != null ? selected.disabled : undefined)) {
      return this.handleSelect(selected);
    }
  };

  handleType = (query, e) => {
    if (query == null) {
      query = "";
    }
    query = query.trim();
    if (typeof this.props.onSearch === "function") {
      this.props.onSearch(query);
    }
    return this.setState({ search: query, selectedIndex: 0 });
  };

  handleSelectAll = () => {
    const all_values = _.compact(
      _.map(this.getSelectable(), function(item) {
        if (!item.disabled) {
          return item;
        }
      })
    );
    return typeof this.props.onChange === "function" ? this.props.onChange(all_values) : undefined;
  };

  handleUnselectAll = () => {
    return typeof this.props.onChange === "function" ? this.props.onChange([]) : undefined;
  };

  renderListItem = (item, key, index) => {
    return AdvancedComboboxItem({
      className: this.props.multiple ? "is-multiple" : undefined,
      item,
      key,
      isSelected: this.isSelected(item),
      isFocused: index === this.state.selectedIndex,
      search: this.state.search,
      onClick: this.handleSelect,
      index,
      onHover: this.handleHover,
      formatItem: this.props.formatItem || formatterFactory(this.props.multiple),
    });
  };

  getHeight = () => {
    let { height } = this.props;
    if (this.props.searchable && !this.props.isOpenedUp) {
      height = height - SEARCH_HEIGHT;
    }
    if (this.props.multiple && (this.props.allowChangeAll || this.props.allowUnselectAll)) {
      height = height - SELECT_ALL_HEIGHT;
    }
    return height || DEFAULT_MAX_HEIGHT;
  };

  render() {
    const selectable = this.getSelectable();
    const list = this.getFilteredList();
    let group_index = -1;

    return React.createElement(
      "div",
      {
        className: classNames("et--advanced-combobox-content", this.props.className),
      }, // Search box for searchable select elements
      this.props.searchable ? (
        <div className="et--advanced-combobox-content--search">
          {ArrowSelectInput({
            type: "search",
            selectedIndex: this.state.selectedIndex,
            maxIndex: selectable.length - 1,
            placeholder: this.props.search_placeholder,
            defaultValue: this.state.search,
            onType: this.handleType,
            onEnter: this.handleKeyEnter,
            onArrow: i => {
              return this.setState({ selectedIndex: i });
            },
            focusOnMount: this.props.focusOnMount,
          })}
        </div>
      ) : (
        undefined
      ), // List / Grouped List Display
      React.createElement(
        "div",
        {
          className: classNames("et--advanced-combobox-content--list", {
            "is-grouped": this.props.grouped,
          }),
          style: {
            maxHeight: !this.props.mobile ? this.getHeight() : undefined,
          },
          onWheel(e) {
            e.stopPropagation();
            return e.nativeEvent.stopImmediatePropagation();
          },
          ref: "list_outer",
        },
        <ul className="et--advanced-combobox-content--list-inner" ref="list_inner">
          {_.isEmpty(selectable) && !!this.state.search && _.isFunction(this.props.createFromSearch) ? (
            this.renderListItem(this.props.createFromSearch(this.state.search), this.state.search, 0)
          ) : _.isEmpty(selectable) ? (
            <div className="et--advanced-combobox-content--text-empty-message">{this.props.empty_placeholder}</div>
          ) : (
            _.map(list, (item, item_index) => {
              if (this.props.grouped) {
                return (
                  <li className="et--advanced-combobox-content--group" key={item.key || item.value || item_index}>
                    <strong className="et--advanced-combobox-content--group-label">
                      {// et--advanced-combobox-content--group-label only used for tests
                      item != null ? item.label : undefined}
                    </strong>
                    <ul>
                      {_.map(item.items, group_item => {
                        group_index += 1;
                        return this.renderListItem(
                          group_item,
                          (item.value || item_index) + group_item.value,
                          group_index
                        );
                      })}
                    </ul>
                  </li>
                );
              } else {
                return this.renderListItem(item, item.value, item_index);
              }
            })
          )}
          {this.props.loading ? (
            <div className="et--advanced-combobox-content--loading-overlay">
              <li className="et--advanced-combobox-content--text-empty-message">
                <i className="fa fa-fw fa-spinner fa-pulse" />Loading...
              </li>
            </div>
          ) : (
            undefined
          )}
        </ul>
      ), // Check / Uncheck all actions
      (() => {
        if (this.props.multiple && this.props.allowChangeAll) {
          return (
            <div className="et--advanced-combobox--selection">
              <strong>{`${(this.props.value != null ? this.props.value.length : undefined) || 0} selected: `}</strong>
              <a className="et--advanced-combobox--selection-link" href="#" onClick={this.handleSelectAll}>
                Select all
              </a>
              <span> | </span>
              <a className="et--advanced-combobox--selection-link" href="#" onClick={this.handleUnselectAll}>
                Unselect all
              </a>
            </div>
          ); // advanced-combobox--selection-link only used for test
        } else if (this.props.multiple && this.props.allowUnselectAll) {
          return (
            <div className="et--advanced-combobox--selection">
              <strong>{`${(this.props.value != null ? this.props.value.length : undefined) || 0} selected: `}</strong>
              <a href="#" onClick={this.handleUnselectAll}>
                Unselect all
              </a>
            </div>
          );
        }
      })()
    );
  }
}
